// extracted by mini-css-extract-plugin
export default {"count":"styles__count___U7pBt","list":"styles__list___7pG8R","listItem":"styles__listItem___Q5rp0","text":"styles__text___pvY71"};